import { CHANGESTATUS_SUCCESS, CHANGESTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const changeRequestStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGESTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CHANGESTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default changeRequestStatusReducer;
